import { render, staticRenderFns } from "./lxwm.vue?vue&type=template&id=3c84ca00&scoped=true"
import script from "./lxwm.vue?vue&type=script&lang=js"
export * from "./lxwm.vue?vue&type=script&lang=js"
import style0 from "./lxwm.vue?vue&type=style&index=0&id=3c84ca00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c84ca00",
  null
  
)

export default component.exports